import { IAdditionalInfoLabelModel, AdditionalInfoLabelModel } from '@common/models';
import { http } from '@common/utils';
import { trackPromise } from 'react-promise-tracker';
import { ServiceHelper } from '../serviceHelper';
import { ServiceMethodOptions } from '../types';

export class AdditionalInfoLabelService {

    private static baseUrl: string = '/api/additionalinfolabel';

    static tags = {
        updateAdditionalInfoLabel: "updateAdditionalInfoLabel",
        deleteAddtionalInfoLabel: "deleteAddtionalInfoLabel"
    }

    /**
     * Updates AdditionalInfoLabel
     * @param data AdditionalInfoLabel Model to update
     * @param options Service Method Options
     * @returns AdditionalInfoLabel Model
     */
    static upsertAdditionalInfoLabel = (data: IAdditionalInfoLabelModel, options?: ServiceMethodOptions): Promise<AdditionalInfoLabelModel> => {
        return trackPromise(new Promise<IAdditionalInfoLabelModel>((resolve, reject) => {
            http(`${this.baseUrl}`).post<IAdditionalInfoLabelModel>(data)
                .then((response) => {
                    ServiceHelper.showSuccess("Additional Info Label updated", options);
                    resolve(new AdditionalInfoLabelModel(response));
                })
                .catch((err) => {
                    ServiceHelper.showError("Failed to update Additional Info Label.", options);
                    reject(err);
                })
        }), this.tags.updateAdditionalInfoLabel);
    }

    static deleteAdditionalInfoLabel = (id: number, options?: ServiceMethodOptions): Promise<boolean> => {
        return trackPromise(new Promise<boolean>((resolve, reject) => {
            http(`${this.baseUrl}/${id}`).delete()
                .then(() => {
                    ServiceHelper.showSuccess("Additional Info Label has been deleted", options);
                    resolve(true);
                })
                .catch((err) => {
                    ServiceHelper.showError("Failed to delete Additional Info Label.", options);
                    reject(err);
                })
        }), this.tags.deleteAddtionalInfoLabel);
    }
}
